import React, { Component } from 'react';
import './CourseDetailStyle.scss';
import "video-react/dist/video-react.css";
import TeacherCard from './components/TeacherCard'
import Loading from 'components/Loading';
import ReactHtmlParser from 'react-html-parser';
import NavBar from 'layouts/public-navbar/NavBarDS';
import Footer from 'layouts/public-footer/Footer';
import { ajaxJson } from 'imports/ajax';
import * as Scroll from 'react-scroll';
import { Player } from 'video-react';
import HLSSource from 'components/HLSSource';
export default class CourseDetailPage extends Component {
    
    state = {
        loading: true,
        periods: [],
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.setState({ loading: true });
        this.props.initData(this.props.match.params.id)
            .then(() => {
                ajaxJson.get(`/courses/${this.props.match.params.id}/periods`)
                .then((res) => {
                    const mappedPeriod = res.data.map((item) => {
                        return {
                            id: item['id'],
                            duration: item['duration'],
                            title: item['title'],
                            chapters: item['chapters'].map((chap) => {
                                return {
                                    id: chap['uid'],
                                    title: chap['title'],
                                }
                            })
                        }
                    });

                    this.setState({
                        loading: false,
                        periods: mappedPeriod,
                    });
                }).catch(err => {
                    this.setState({
                        loading: false,
                        periods: [],
                    });
                })
            });
    }

    makeTeachers() {
        if (this.props.course === null) {
            return;
        }
        return this.props.course.teachers.map((teacher, index) => {
            return (
                <TeacherCard key={index} teacher={teacher} />
            );
        });
    }

    renderTeachers() {
        return this.props.course.teachers.map((item, index) => {
            return (
                <div key={index} className="col-sm-3 col-md-3 col-xs-5">
                    <TeacherCard teacher={item} />
                </div>
            )
        })
    }

    renderPeriods() {
        const periods = this.state.periods;
        if (!periods) {
            return '';
        }

        return periods.map((period) => {
            return (
                <li key={period.id}>
                    <span className="period">{period.title}</span>
                    <ul>
                        {period.chapters.map(chap => (
                            <li key={chap.id}>{chap.title}</li>
                        ))}
                    </ul>
                </li>
            )
        })
    }

    render() {
        const { course } = this.props;

        const header = '';

        if (this.state.loading) {
            return (
                <div>
                    {header}
                    <Loading />
                </div>
            )
        }

        return (
            <div className="course-detail">
                <NavBar />
                <header className="header dr-padding" style={{backgroundImage: `url(${course.image})`}}>
                    <div className="info">
                        <div className="text">
                            <h1>{course.title}</h1>
                            <p>{course.summary}</p>
                        </div>
                        <div className="video-wrapper">
                            {
                                course.video && (        
                                    // <video src={course.video} controls>
                                    // </video>
                                    <Player>
                                        <HLSSource
                                            isVideoChild
                                            src={course.video}
                                        />
                                    </Player>
                                )
                            }
                        </div>
                    </div>
                    <div className="overlay"></div>
                </header>
                <div className="navigation">
                    <ul>
                        <li className="active">
                            <Scroll.Link to={'course-description'} smooth={true} offset={0} duration={500}>درباره درس</Scroll.Link>
                        </li>
                        <li>
                            <Scroll.Link to={'course-chapters'} smooth={true} offset={0} duration={500}>سرفصل درس</Scroll.Link>
                        </li>
                        <li>
                            <Scroll.Link to={'course-teachers'} smooth={true} offset={0} duration={500}>اساتید</Scroll.Link>
                        </li>
                        <li>
                            <Scroll.Link to={'course-goals'} smooth={true} offset={0} duration={500}>اهداف درس</Scroll.Link>
                        </li>
                    </ul>
                </div>
                <Scroll.Element name="course-description">
                <section id="about-course" className="dr-margin">
                    <div className="right-box">
                        <h3>درباره درس</h3>
                        <div className="course-description">
                            {ReactHtmlParser(course.description)}
                        </div>
                    </div>
                    <div className="left-box">
                        <ul>
                            <li>در یک نگاه</li>
                            <li>
                                <img src="/images/time.svg" alt="icon" />
                                طول درس:&nbsp;
                                <span>6 هفته</span>
                            </li>
                            <li>
                                <img src="/images/term.svg" alt="icon" />
                                <span>1</span>
                                &nbsp;ترم
                            </li>
                            <li>
                                <img src="/images/comment.svg" alt="icon" />
                                امکان پرسش و پاسخ
                            </li>
                        </ul>
                    </div>
                </section>
                </Scroll.Element>
                <div className="video-wrapper-mobile">
                    {
                        course.video && (
                            <Player>
                                <HLSSource
                                    isVideoChild
                                    src={course.video}
                                />
                            </Player>
                        )
                    }
                </div>
                <Scroll.Element name="course-chapters">
                <section id="syllabus" className="dr-padding">
                    <h3>سرفصل درس</h3>
                    <ul className="custom">
                        {this.renderPeriods()}
                    </ul>
                </section>
                </Scroll.Element>
                <section id="teachers" className="dr-margin">
                    <Scroll.Element name="course-teachers">
                    <h3>اساتید درس</h3>
                    <p style={{paddingBottom: '30px'}}>با تجربه‌ی تحصیل و تدریس در دانشگاه های معتبر سراسر دنیا</p>
                    <img src="/images/img-object-teachers.svg" className="object-icon" alt="icon" />
                    <div className="row">
                        
                        {this.renderTeachers()}
                    </div>
                    </Scroll.Element>
                    <Scroll.Element name="course-goals">
                    <div className="forlearn">
                        <h3>در این درس خواهید آموخت:</h3>
                        <div className="course-description">
                            {ReactHtmlParser(course.secondDescription)}
                        </div>
                    </div>
                    </Scroll.Element>
                </section>
                <Footer />
            </div>
        );
    }
}